define ['./edit.scss'], () ->
  ($scope, $state, $rootScope, $timeout, $stateParams, HOST, landlord, applicationTemplate, RENTAPPLICATION_API_URL, $http, INFO_PAGE_SLUGS) ->
    $scope.landlord = landlord
    $scope.apptemplate = applicationTemplate
    $scope.report_source_profiles = $scope.landlord.report_source_profiles
    $scope.selected = {}
    $scope.total_price = $scope.apptemplate.price
    $scope.smartmove_disabled = {}
    $scope.saving_form = false
    $scope.slug_error_message = ""

    $scope.mobile_view = window.innerWidth < 768

    if not $scope.apptemplate.can_edit
      $state.go "root.home.403"

    $scope.data = 
      name: $scope.apptemplate.name,
      slug: $scope.apptemplate.slug,
      fee: $scope.apptemplate.fee

    $scope.format_rsp = (rsps) ->
      formatted_rsps = rsps.map((rsp) -> 
        if rsp.source_identifier.indexOf('identity') >= 0
          rsp.select_report_label = "Identity Verification"
          rsp.order = 0
          rsp.process_label = "Typically processed within few minutes after applicant completes the verification"
          rsp.tooltip_label = "We send a link to the applicant to complete the identity verification process powered by Stripe."
          
        if rsp.source_identifier.indexOf('credit') >= 0
          rsp.process_label = "Typically processed within 5 minutes. Soft inquiry on credit file."
          rsp.order = 1
          
          if rsp.source_identifier.indexOf('experian') >= 0
            rsp.select_report_label = "Credit Report by Experian"
            rsp.tooltip_label = "Comprehensive credit reporting including Vantage score, detailed trade line information, public records, and more provided by Experian"
          else if rsp.source_identifier.indexOf('zip_report') >= 0
            rsp.select_report_label = "Credit Report by Transunion"
            rsp.tooltip_label = "Comprehensive credit reporting including Vantage score, detailed trade line information, public records, and more provided by Transunion"
          else
            rsp.select_report_label = "Credit Report by Transunion"
            rsp.tooltip_label = "Comprehensive credit reporting including FICO score, detailed trade line information, public records, and more provided by Transunion"
          

        if rsp.source_identifier.indexOf('criminal') >= 0
          rsp.select_report_label = "Criminal Record Search"
          rsp.order = 2
          rsp.process_label = "Typically processed within 5 minutes"
          rsp.tooltip_label = "Criminal background search of over 500 MILLION records from all 50 states and includes a bonus FREE search of sex and violent offender criminal records and terrorist check"

        if rsp.source_identifier.indexOf('eviction') >= 0
          rsp.select_report_label = "Evictions, Judgements, and Liens"
          rsp.order = 3
          rsp.process_label = "Typically processed within 5 minutes"
          rsp.tooltip_label = "Database of millions of public records for eviction filings, liens, civil suits, and judgements. This report may disclose additional information about a prospective tenant that would not always show up on a credit report or criminal background check. Supports all 50 states, but county coverage may vary."

        if rsp.source_identifier.indexOf('employment') >= 0
          rsp.select_report_label = "Employment Verification"
          rsp.order = 4
          rsp.process_label = "Typically processed within 3 business days"
          rsp.tooltip_label = "We contact the applicant’s stated employer to confirm their status and other details about their employment. Because this report requires the current employer’s participation, reports may be delayed up to 3 business days. If after 3 business days the employer does not respond to our inquiry, the inquiry will be closed."
          
          if rsp.source_identifier.indexOf('plus') >= 0
            rsp.select_report_label = "Income Verification +"
            rsp.tooltip_label = "We contact the applicant’s stated employer to confirm their status and other details about their employment. Applicant can also verify their income by connecting their bank account. Because this report requires the current employer’s and applicant's participation, reports may be delayed up to 3 business days. If after 3 business days the employer does not respond to our inquiry, the inquiry will be closed."
        
        if rsp.identifier.indexOf('landlord') >= 0
          rsp.process_label = "Typically processed within 3 business days"
          type = if rsp.source_identifier.indexOf('previous') >= 0 then 'previous' else 'current'
          rsp.tooltip_label = "We confirm the applicant’s residence and reputation with the primary contact at their #{type} address. Because this report requires the #{type} landlord’s participation, reports may be delayed up to 3 business days. If after 3 business days the #{type} landlord does not respond to our inquiry, the inquiry will be closed."
          if rsp.source_identifier.indexOf('current') >= 0 or rsp.source_identifier == 'mvga_landlord'
            rsp.select_report_label = "Current Residence Verification"
            rsp.order = 5
          else
            rsp.select_report_label = "Previous Residence Verification"
            rsp.order = 6
        return rsp
      )
      return _.orderBy(formatted_rsps, ['order'])
    
    $scope.report_source_profiles = $scope.format_rsp($scope.report_source_profiles)

    $scope.go_to_verification = (vendor) ->
      $rootScope.stored_form_data = $scope.data
      $state.go('root.verifications.disclaimer', { vendor: vendor })

    if _.find(landlord.report_source_profiles, (rsp) -> _.startsWith(rsp.identifier, 'smartmove') and rsp.active == false)
      $scope.go_to_verification('smartmove')

    $scope.update_smartmove_disabled = () ->
      if $scope.selected['smartmove_core']
        $scope.smartmove_disabled['smartmove_plus'] = true
      else
        $scope.smartmove_disabled['smartmove_plus'] = false
      
      if $scope.selected['smartmove_plus']
        $scope.smartmove_disabled['smartmove_core'] = true
      else
        $scope.smartmove_disabled['smartmove_core'] = false
    
    # Set currently selected report sources on
    selected_identifiers = $scope.apptemplate.selected_report_sources.map((rsp) -> rsp.replace('/api/v1/reportsource/', '').replace('/', ''))

    for rsp in $scope.report_source_profiles
      if rsp.active and rsp.identifier.indexOf('smartmove') < 0 and selected_identifiers.indexOf(rsp.identifier) >= 0
        $scope.selected[rsp.identifier] = true
      
      # Customize smartmove rsp
      if rsp.identifier.indexOf('smartmove') >= 0
        $scope.update_smartmove_disabled()
      
    $scope.error_message = !_.some((v for k, v of $scope.selected), (o) -> o ) && !landlord.verified

    $scope.$watch(() ->
      $scope.data.fee
    , (newVal, oldVal) ->
      $scope.total_price = $scope.total_price + Number(newVal or '0') - Number(oldVal or '0')
    )

    $scope.select_rsp = (index) ->
      rsp = _.find($scope.report_source_profiles, (o) -> o.identifier == index)

      if !rsp.active or $scope.smartmove_disabled[index]
        return
      
      $scope.selected[index] = !$scope.selected[index]

      $scope.update_smartmove_disabled()

      if $scope.selected[index]
        $scope.total_price += rsp.price
      else
        $scope.total_price -= rsp.price

      $scope.error_message = !_.some((v for k, v of $scope.selected), (o) -> o ) && !landlord.verified
    
    $scope.cancel = () ->
      $state.go("root.dashboard.forms")

    $scope.check_slug = () ->
      $scope.data.slug = $scope.data.slug.toLowerCase()

      if $scope.data.slug.length < 6
        $scope.slug_error_message = "URL link must be at least 6 characters long"
        return
      if /^\d+$/.test($scope.data.slug)
        $scope.slug_error_message = "URL link must contain at least one letter"
        return
      if $scope.data.slug in INFO_PAGE_SLUGS
        $scope.slug_error_message = "URL link is already taken, please try another"
        return
      # If no error, reset the error message
      $scope.slug_error_message = ""


    $scope.save_apptemplate = () ->
      $scope.data.fee = Number($scope.data.fee or 0)

      if $scope.slug_error_message
        el = $('#form_slug')
        $("body").animate({ scrollTop: el.offset().top }, "slow")
        return
      
      $scope.saving_form = true

      $scope.data.selected_reports = _.compact(Object.keys($scope.selected).map(
        (key) -> 
          if $scope.selected[key]
            return key
          return null
        )
      )

      $http.patch("#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/#{$scope.apptemplate.id}/edit/", $scope.data)
      .then (response) ->
        $rootScope.$broadcast("forms-changed")
        $state.go("root.dashboard.forms")
      .catch (error)->
        console.log(error)
      .finally () ->
        $scope.saving_form = false
    
    $scope.go_to_customize = () ->
      $state.go("root.applications.customize", { application_template_slug: $scope.apptemplate.slug })



// WEBPACK FOOTER //
// ./components/applications/edit/edit.coffee